export default __webpack_public_path__ + "static/Daikin-a1a276726eeabff253665b7473dd03ee.jpg";